export default {
    of: 'de',
    back: 'Volver',
    filtered: 'Filtrado',
    willDownloadOnly: 'Solo se va a descargar',
    teacherProfile: 'Perfil Docente',
    filterBy: 'Filtrar por',
    selectOneOrSeveral: 'Seleccione uno o varios para filtrar.',
    noResultsFor: 'No se encontró resultados para',
    planLevel: 'Nivel de Plan',
    number: 'N°',
    minimum: 'Mínimas',
    confirmationRequired: 'Confirmación Necesaria',
    areYouSureClose: '¿Estás seguro de que quieres cerrar? Los datos no guardados se perderán.',
    yesClose: 'Sí, cerrar',
    completitudeAbbr: 'COMPLETITUD PMD',
    reportOf: 'REPORTE DE',
    formativeMap: 'MAPA FORMATIVO',
    linkTo: 'Vincular {object} a {entity}',
    updatedPlural: 'actualizadas.',
    expandRow: 'Expandir fila',
    collapseRow: 'Contraer fila',
    expandAllRows: 'Expandir todas las filas',
    collapseAllRows: 'Contraer todas las filas',
    showAllItems: 'Ver los {count} elementos de esta columna',

    // ========== CompetenceUnitForm ==========
    details: 'Detalles',
    weighing: 'Ponderación',
    equivalentWeighing: 'Ponderación equivalente',
    canAddName: 'Puede agregarle un nombre al {entity}.',
    specifyPercentage: 'Especifica el porcentaje de tributación para la {entity}.',
    canSpecifyPosition: 'Puede especificar la posición o el orden.',
    useEquivalentWeighing: 'Utilizar una ponderación equivalente para los {entity}',
    availableWeighingIs: 'La ponderación disponible es de',
    requiredFieldMaxPercent: 'Este campo es obligatorio y no debe exceder {percent}%.',
    created: 'creado.',
    updated: 'actualizado.',

    // ========== RAMacroForm ==========
    areYouSureDelete: '¿Está seguro de que lo desea eliminar?',
    deleted: 'eliminado.',

    // ========== Reportes IA ==========
    evolutiveReportTitle: 'Análisis Evolutivo–Comparativo de la {entity}',
    evolutiveButtonText: 'Análisis Evolutivo {entity}',
    evolutiveButtonTooltip: 'Analizar coherencia, progresión y tributación de la {entity} con IA',
    improvementReportTitle: 'Propuesta de Mejora de la {entity}',
    improvementButtonText: 'Propuesta de Mejora {entity}',
    improvementButtonTooltip: 'Generar propuesta de mejoras de {raEntity} y tributación con IA',
}
